<!-- Selected BU + search row + table: flex column so table scrolls -->
<div
  data-testid="business-unit-management-container"
  class="flex flex-col min-h-0 flex-1 overflow-hidden"
>
  <!-- Selected Business Unit row (above everything) -->
  <div class="mb-3 flex-shrink-0">
    @if (selectedUnitNameSignal()) {
      <span
        class="inline-flex items-center rounded-full bg-blue-50 px-3 py-1 text-sm font-medium text-blue-700"
      >
        {{ selectedUnitNameSignal() }}
      </span>
    } @else {
      <span class="text-sm text-gray-500">
        {{
          "configuration.business_unit.table.select_unit_to_view_users"
            | translate
        }}
      </span>
    }
  </div>

  <!-- Search + Actions row: search input + clear on left, Unassign/Assign on right, same line -->
  @if (selectedUnitNameSignal()) {
    <app-search-form
      data-testid="business-unit-management-user-search-form"
      class="bu-users-search-row"
      [searchFormat]="userSearchConfig"
      (formSearch)="onUserSearch($event)"
      (formReset)="onUserSearchReset()"
    >
      @if (canUpdate() && canAssignUsersSignal()) {
        <div slot="actions" class="flex items-center gap-2 flex-shrink-0">
          <app-button
            [testId]="'business-unit-management-unassign-users-btn'"
            [label]="
              'configuration.business_unit.table.action_buttons.unassign_users'
                | translate
            "
            type="danger"
            [outlined]="true"
            [disabled]="selectedUsers().length === 0 || isUnassigningMultiple()"
            [loading]="isUnassigningMultiple()"
            (emitOnClick)="onUnassignUsers()"
          ></app-button>
          <app-button
            [testId]="'business-unit-management-assign-user-btn'"
            [label]="
              'configuration.business_unit.table.action_buttons.assign_user'
                | translate
            "
            type="info"
            (emitOnClick)="onAssignUser()"
          ></app-button>
        </div>
      }
    </app-search-form>
  }

  <div class="users-table-container flex-1 min-h-0">
    <app-data-table
      data-testid="business-unit-management-users-table"
      [dataSource]="usersSignal()"
      [columns]="userColumns()"
      [loading]="usersLoadingSignal()"
      [rows]="20"
      [first]="0"
      [totalRecords]="usersSignal().length"
      [showPaginator]="false"
      [scrollHeight]="'flex'"
      [hasCheckColumn]="canUpdate() && canAssignUsersSignal()"
      [selection]="selectedUsers()"
      (selectionChange)="onSelectionChange($event)"
      class="w-full"
    >
      <!-- Custom Status Template -->
      <ng-template #statusTemplate let-status let-rowData="rowData">
        <div class="flex items-center justify-center gap-1">
          @if (status && status !== "--") {
            <p-tag
              [attr.data-testid]="
                'business-unit-management-status-tag-' +
                (rowData._original?.id || rowData.email || rowData.username)
              "
              [value]="status"
              [severity]="getStatusSeverity(status)"
              styleClass="status-tag"
              [pTooltip]="status"
              tooltipPosition="top"
              tooltipStyleClass="custom-tooltip"
              [showDelay]="300"
              [hideDelay]="0"
            ></p-tag>
          } @else {
            <span class="text-sm text-gray-400">--</span>
          }
        </div>
      </ng-template>

      <!-- Custom Actions Template -->
      <ng-template #actionsTemplate let-rowData>
        <div class="flex gap-2 justify-center">
          @if (canUpdate() && canAssignUsersSignal()) {
            <button
              [attr.data-testid]="
                'business-unit-management-unassign-user-btn-' +
                (rowData._original?.id || rowData.email || rowData.username)
              "
              type="button"
              (click)="isUnassigning(rowData) ? null : onUnassignUser(rowData)"
              [disabled]="isUnassigning(rowData)"
              class="action-link action-delete"
              [class.cursor-pointer]="!isUnassigning(rowData)"
              [class.disabled]="isUnassigning(rowData)"
            >
              @if (isUnassigning(rowData)) {
                {{
                  "configuration.business_unit.table.loading.unassigning_user"
                    | translate
                }}
              } @else {
                {{
                  "configuration.business_unit.table.action_buttons.unassign_user"
                    | translate
                }}
              }
            </button>
          }
        </div>
      </ng-template>
    </app-data-table>
  </div>
</div>

<app-confirmation-dialog
  data-testid="business-unit-management-unassign-confirmation-dialog"
  [visible]="unassignConfirmVisible()"
  (visibleChange)="onUnassignConfirmVisibleChange($event)"
  [title]="unassignConfirmTitle()"
  [message]="unassignConfirmMessage()"
  [buttons]="unassignConfirmButtons()"
  (emitOnClick)="onUnassignConfirmAction($event)"
></app-confirmation-dialog>
